import { AppRoutes, ERROR_ROUTES, ROUTE_LABELS } from '@/constants';
import { NavRoute } from '@/types';

const getRouteLabel = (path: string) => {
  return ROUTE_LABELS[path as NavRoute];
};

const getBreadcrumbItems = (pathname: string) => {
  if (ERROR_ROUTES.includes(pathname)) {
    return [];
  }

  const pathSegments = pathname.split('/').filter(Boolean);

  const breadcrumbItems = pathSegments
    .map((segment, index) => {
      const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
      const isLastSegment = index === pathSegments.length - 1;

      // Find a matching route pattern from AppRoutes
      const routePattern = Object.values(AppRoutes).find((pattern) => {
        const patternParts = pattern.split('/').filter(Boolean);
        const pathParts = url.split('/').filter(Boolean);

        if (patternParts.length !== pathParts.length) {
          return false;
        }

        return patternParts.every((part, i) => {
          return part.startsWith(':') || part === pathParts[i];
        });
      });

      // Check if the current segment is a dynamic part of the route
      if (routePattern) {
        const patternParts = routePattern.split('/').filter(Boolean);
        const lastPatternPart = patternParts[patternParts.length - 1];
        if (lastPatternPart.startsWith(':')) {
          // This is a dynamic segment
          if (isLastSegment) {
            // Show the actual value if it's the last segment
            return { url, label: segment };
          } else {
            // Skip dynamic segments that are not the last one
            return null;
          }
        }
      }

      const label = getRouteLabel(routePattern || url);

      if (!label) {
        // Skip segments that don't have a matching route label
        return null;
      }

      return { url, label };
    })
    .filter(Boolean) as { url: string; label: string }[];

  if (pathname === '/') {
    return [{ url: '/', label: getRouteLabel('/'), isLast: true }];
  }

  return breadcrumbItems.map((item, index) => ({
    ...item,
    isLast: index === breadcrumbItems.length - 1,
  }));
};

export { getBreadcrumbItems };
